import script from "./LeaderboardRow.vue?vue&type=script&setup=true&lang=js"
export * from "./LeaderboardRow.vue?vue&type=script&setup=true&lang=js"

import "./LeaderboardRow.vue?vue&type=style&index=0&id=732352b3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-732352b3"]])

export default __exports__